var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransmission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 26H14v9h21v-9z",
    fill: "currentColor",
    stroke: "#FAFAFA",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 6H19v38h12V6zM25 9v18M19 21h-3M19 11h-3M19 40h-3M25 34v7",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26v9M28 26v9",
    stroke: "#FAFAFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 29h-3v3h3v-3zM9.088 8.4c.496 0 .925.083 1.288.248.368.165.65.4.848.704.197.304.296.664.296 1.08 0 .41-.099.77-.296 1.08-.197.304-.48.539-.848.704-.363.16-.792.24-1.288.24H7.96V14H6.664V8.4h2.424zm-.072 3c.39 0 .685-.083.888-.248.203-.17.304-.41.304-.72 0-.315-.101-.555-.304-.72-.203-.17-.499-.256-.888-.256H7.96V11.4h1.056zM10.232 24l-1.08-1.56H7.96V24H6.664v-5.6h2.424c.496 0 .925.083 1.288.248.368.165.65.4.848.704.197.304.296.664.296 1.08 0 .416-.101.776-.304 1.08-.197.299-.48.528-.848.688l1.256 1.8h-1.392zm-.024-3.568c0-.315-.101-.555-.304-.72-.203-.17-.499-.256-.888-.256H7.96v1.952h1.056c.39 0 .685-.085.888-.256.203-.17.304-.41.304-.72zM11.8 27.4V33h-1.064l-2.792-3.4V33h-1.28v-5.6h1.072l2.784 3.4v-3.4h1.28zM6.664 37.4h2.544c.608 0 1.144.117 1.608.352.47.23.832.555 1.088.976.261.421.392.912.392 1.472 0 .56-.13 1.05-.392 1.472a2.6 2.6 0 0 1-1.088.984c-.464.23-1 .344-1.608.344H6.664v-5.6zm2.48 4.536c.56 0 1.005-.155 1.336-.464.336-.315.504-.739.504-1.272s-.168-.955-.504-1.264c-.33-.315-.776-.472-1.336-.472H7.96v3.472h1.184z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransmission);
export default __webpack_public_path__ + "static/media/transmission.f5ea7d2085c685b7d93aca9fb384bf2c.svg";
export { ForwardRef as ReactComponent };